import { ContentLoader } from '../ContentLoader'

const JobBlockLoader = (keyIndex) => {
	return <ContentLoader height={100} />
}

export default JobBlockLoader
